/**
 * @Author: Ali
 * @Date:   2019-03-22T12:29:47+01:00
 * @Last modified by:   Ali
 * @Last modified time: 2019-03-22T12:30:36+01:00
 */
export const data = [
  "hat",
  "river",
  "lucky",
  "statue",
  "generate",
  "stubborn",
  "cocktail",
  "runaway",
  "joke",
  "developer",
  "establishment",
  "hero",
  "javascript",
  "nutrition",
  "revolver",
  "echo",
  "siblings",
  "investigate",
  "horrendous",
  "symptom",
  "laughter",
  "magic",
  "master",
  "space",
  "definition"
];
